import * as React from 'react';

import type { CloudProviderNames } from 'common/components/CloudProvidersContext/CloudProvidersContext';
import Link from 'common/components/core/Link/Link';
import type { BillingSubscriptionsResponse } from 'common/components/SubscriptionStatusBanner/fragments';
import { ClustersSubscriptionStatus } from 'common/components/SubscriptionStatusBanner/fragments';
import { getConfig } from 'common/helpers/configHelper';

export const getBlockedActionsMessage = (
  cloudProvider: CloudProviderNames,
  billingSubscriptions?: BillingSubscriptionsResponse[] | undefined
) => {
  if (!billingSubscriptions || billingSubscriptions.length === 0) {
    return null;
  }

  if (
    billingSubscriptions.some(
      subscription =>
        subscription.clustersSubscriptionStatus === ClustersSubscriptionStatus.TRIAL_PERIOD_EXPIRED &&
        subscription.cloudProvider === cloudProvider
    )
  ) {
    return (
      <>
        Your NC2 Trial has expired. Please upgrade to a paid subscription from the{' '}
        <Link href={getConfig().nutanixClustersBillingUrl!} external={true} className="cluster-settings__link-alert">
          Nutanix billing center.
        </Link>
      </>
    );
  }

  if (
    billingSubscriptions.some(
      subscription =>
        subscription.clustersSubscriptionStatus === ClustersSubscriptionStatus.TRIAL_PERIOD_CANCELLED &&
        subscription.cloudProvider === cloudProvider
    )
  ) {
    return (
      <>
        Your NC2 Trial has been cancelled. Please upgrade to a paid subscription from the{' '}
        <Link href={getConfig().nutanixClustersBillingUrl!} external={true} className="cluster-settings__link-alert">
          Nutanix billing center.
        </Link>
      </>
    );
  }

  return null;
};

export const sortAlphabetically = (item1: string, item2: string) => {
  return item1.toLowerCase().localeCompare(item2.toLowerCase());
};
